import { TableCell, TableRow } from '@repo/ui/components'
import { Heading } from '../Atoms'
import { FuzeLogoLoader } from '../Logo'

const loadingTextOptions = [
  'Crunching numbers...',
  'Herding data points...',
  'Untangling spreadsheets...',
  'Connecting the dots...',
  'Processing ones and zeros...',
  'Making data beautiful...',
]

type LoadingStateProps = {
  colSpan: number
}

export function LoadingState(props: LoadingStateProps) {
  return (
    <TableRow>
      <TableCell colSpan={props.colSpan} className="h-96 text-center">
        <div className="flex flex-col items-center justify-center gap-6">
          <FuzeLogoLoader isLoading logoOnly className="size-16 opacity-20" />
          <Heading level={4} weight="weak" leading="none" className="opacity-30">
            {loadingTextOptions[Math.floor(Math.random() * loadingTextOptions.length)]}
          </Heading>
        </div>
      </TableCell>
    </TableRow>
  )
}
